import Chat from "./Chat"
import ChatInput from "./ChatInput";
import axios from 'axios';
import {useState, useEffect} from "react";
import config from "../config";

const ChatDisplay = ({user,clickedClothes}) => {
    const userId = user?.user_id
    const clickedClothesId = clickedClothes?._id
    const clickedClothesOwnerId = clickedClothes?.ownerId
    const [usersMessages, setUsersMessages] = useState(null)
    const [clickedUsersMessages, setClickedUsersMessages] = useState(null)
    const [otherUser, setOtherUser] = useState(null)
    

    const getOtherUser = async () => {
        try{
            const response = await axios.get(`${config.apiUrl}user`,{
                headers: {"token": localStorage.getItem("token")},
                params: {userId: clickedClothesOwnerId}
            })
            setOtherUser(response.data)
        }
        catch(error){
            console.log(error)
        }
    }

    const getMessages = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}messages`, {
                headers: {"token": localStorage.getItem("token")},
                params: {userId: userId, correspondingUserId: clickedClothesOwnerId,
                        clickedClothesId: clickedClothesId, tryBoth: true
                }
            })
            let userMessages = []
            let clickedUsersMessages = []
            for (let index in response.data){
                let message = response.data[index]
                if (message.userId === userId){
                    userMessages.push(message)
                }
                else{
                    clickedUsersMessages.push(message)
                }
            }
            setUsersMessages(userMessages)
            setClickedUsersMessages(clickedUsersMessages)
        }
        catch(error){
            console.log(error)
        }

    }

    useEffect(() => {
        getOtherUser()
        getMessages()
    },[usersMessages])

    //console.log("otherUser: ",otherUser)
    const messages = []

    usersMessages?.forEach(message =>{
        const formattedMessage = {}
        formattedMessage['img'] = message.img
        formattedMessage['message'] = message.message
        formattedMessage['from_userId'] = message.from_userId
        formattedMessage['timestamp'] = message.timestamp
        messages.push(formattedMessage)
    })

    clickedUsersMessages?.forEach(message =>{
        const formattedMessage = {}
        formattedMessage['img'] = message.img
        formattedMessage['message'] = message.message
        formattedMessage['from_userId'] = message.from_userId
        formattedMessage['timestamp'] = message.timestamp
        messages.push(formattedMessage)

    })
    const descendingOrderMessages = messages?.sort((a,b) => a.timestamp.localeCompare(b.timestamp))

    return(
        <>
        <Chat descendingOrderMessages={descendingOrderMessages} user={user} otherUser={otherUser}/>
        <ChatInput
            user={user}
            otherUserId={clickedClothes?.ownerId}
            clickedClothesId={clickedClothesId}
        />
        </>
    )
}
export default ChatDisplay